// import { useState, useEffect } from "react";
// import "./ProductOverview.css";

// //import axios from "axios";
// import tomatoa from "./Images/tomatoa.png";
// import tomatob from "./Images/tomato-2.png";
// import tomatoc from "./Images/tomato5.png";
// import tomatod from "./Images/tomatod.png";
// import { FaCircleUser } from "react-icons/fa6";

// function ProductOverview() {
//   const [image, setimage] = useState(tomatoa);
//   return (
//     <>
//       <div id="total">
//         <div className="head">
//           <h1 id="head-1">Product</h1>
//           <span id="head-2"> Products / Product</span>
//         </div>
//         <div className="pro ">
//           <div className="pro-imgs">
//             <div id="img1" onClick={() => setimage(tomatoa)}>
//               <img src={tomatoa} alt="img" />
//             </div>
//             <div id="img1" onClick={() => setimage(tomatob)}>
//               <img src={tomatob} alt="img" />
//             </div>
//             <div id="img1" onClick={() => setimage(tomatoc)}>
//               <img src={tomatoc} alt="img" />
//             </div>
//             <div id="img1" onClick={() => setimage(tomatod)}>
//               <img src={tomatod} alt="img" />
//             </div>
//           </div>
//           <div id="product-img">
//             <img src={image} alt="image" />
//           </div>
//           <div id="product-de">
//             <span id="product-de1"> Boxaio</span>
//             <p id="product-de2">|Tomatoes|</p>
//             <div>
//               <label htmlFor="dropdown">Price:</label>
//               <select id="dropdown">
//                 <option value="19">Grade-1 19rs/kg.</option>
//                 <option value="15">Grade-2 15rs/kg.</option>
//               </select>
//             </div>
//             <div>
//               <label htmlFor="kg">Quantity:</label>
//               <input type="number" id="kg" />
//             </div>
//             <div id="total-p">
//               <p></p>
//             </div>
//             <div className="pro-bt">
//               <button id="add-cart">Add to cart</button>
//               <button id="buy-now">Buy Now</button>
//             </div>
//             <div id="pro-des">
//               <p id="product-des">
//                 Dive into the vibrant world of flavor with our fresh and juicy
//                 vine-ripened tomatoes. Grown under the warm sun and harvested at
//                 peak ripeness, these tomatoes are bursting with natural
//                 sweetness. Ideal for salads, sauces, and sandwiches, elevate
//                 your culinary creations with the goodness of our premium
//                 tomatoes.
//               </p>
//               <p id="product-des">
//                 Tomatoes are a low-calorie delight, providing only about 22
//                 calories per 100 grams, while offering a rich source of
//                 essential nutrients like vitamin C, potassium, and folate.
//               </p>
//             </div>
//           </div>
//         </div>
//         <div id="pro-deli">
//           <div class="address">
//             <h3>Delivery Address:</h3>
//             <p>
//               <strong>Name:</strong>John Doe
//             </p>
//             <p>
//               <strong>Address:</strong> 123 Main Street
//             </p>
//             <p>
//               <strong>city:</strong> Anytown
//             </p>
//             <p>
//               <strong>state:</strong> CA
//             </p>
//             <p>
//               <strong>Zip code:</strong> 12345
//             </p>
//           </div>
//           <div class="contact-info">
//             <h3>Contact Information:</h3>
//             <p>
//               <strong>Phone:</strong> (555) 555-5555
//             </p>
//             <p>
//               <strong>Email:</strong>: john.doe@example.com
//             </p>
//           </div>
//         </div>
//         <div id="pro-scroll">
//           <div className="pro-scrollitems">a</div>
//           <div className="pro-scrollitems">b</div>
//           <div className="pro-scrollitems">c</div>
//           <div className="pro-scrollitems">d</div>
//           <div className="pro-scrollitems">e</div>
//           <div className="pro-scrollitems">e</div>
//           <div className="pro-scrollitems">e</div>
//         </div>

//         <div id="pro-reviews">
//           <h1>Customer Reviews</h1>
//           <div class="review">
//             <h2 class="customer-name">
//               <FaCircleUser /> Ashley <span id="rating">★★★★★</span>
//             </h2>
//             <p>
//               Absolutely love these tomatoes! They arrived fresh and juicy, and
//               the flavor is outstanding. I use them for salads, sauces, and
//               sandwiches. The packaging was excellent, ensuring that they stayed
//               in perfect condition during transit. Will definitely be ordering
//               again!
//             </p>
//           </div>

//           <div class="review">
//             <h2 class="customer-name">
//               <FaCircleUser /> Sarah <span id="rating">★★★★☆</span>
//             </h2>
//             <p>
//               Tomatoes by FreshHarvest are a game-changer! The vibrant color and
//               taste made my homemade salsa a hit at the recent family gathering.
//               They were delivered promptly and in great shape. I appreciate the
//               quality, and I'll be returning for more soon.
//             </p>
//           </div>

//           <div class="review">
//             <h2 class="customer-name">
//               <FaCircleUser /> Alex <span id="rating">★★★★★</span>{" "}
//             </h2>
//             <p>
//               Hey there, it's Alex! These tomatoes from GardenGoodies exceeded
//               my expectations. Super fresh, plump, and bursting with flavor.
//               Used them in a caprese salad, and it was a hit! Kudos to the
//               growers. A definite repeat purchase for me!
//             </p>
//           </div>
//         </div>
        
//       </div>
//     </>
//   );
// }

// export default ProductOverview;
import React from 'react'

function ProductOverview() {
  return (
    <div>ProductOverview</div>
  )
}

export default ProductOverview